import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuditLocation } from '../../core-module/models/Locations/audit-location';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { Question } from 'src/app/core-module/models/Audits/question';
import { QuestionHolder } from 'src/app/core-module/models/Audits/question-holder';
import { FlattenedQuestionHolder } from 'src/app/core-module/models/Audits/flattened-question-holder';
import { UserLocationSave } from 'src/app/core-module/models/user-location-save';
import { AuditGuidService } from 'src/app/core-module/services/audits/audit-guid.service';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { LocalStorageService } from 'src/app/core-module/services/local-storage.service';
import { QuestionCompletionInfo } from 'src/app/core-module/models/Audits/question-completion-info';
import { AuditHolder } from 'src/app/core-module/models/Audits/audit-holder';
import { BasicUser } from 'src/app/core-module/models/basic-user';
import { BasicResult } from 'src/app/core-module/models/basic-result';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { ActionResult } from 'src/app/core-module/models/Compliance-Actions/action-result';
import { QuestionAnswer } from 'src/app/core-module/models/Audits/question-answer';
import { SupportRequest } from 'src/app/core-module/models/CustomerSupport/support-request';
import { ComplianceActionService } from 'src/app/core-module/services/compliance-action.service';
import { ActionUserRequest } from 'src/app/core-module/models/Compliance-Actions/action-user-request';
import { AuditResult } from 'src/app/core-module/models/Audits/audit-result';
import { Observable, Subscription, tap, fromEvent, catchError, of } from 'rxjs';
import { BackupAudit } from 'src/app/core-module/models/Audits/backup-audit';

@Component({
  selector: 'app-audit-main',
  templateUrl: './audit-main.component.html',
  styleUrls: ['./audit-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AuditMainComponent {

  location: AuditLocation;
  EventWorkflowID: number = -1;
  //audit: FlattenedQuestionHolder;
  //completeAudit: Audit;
  pageReady: boolean = false;
  currentQuestion: Question = new Question();
  currentData: FlattenedQuestionHolder = new FlattenedQuestionHolder();
  currentHeader: string = '';
  submitting: boolean = false;
  submittingIssue: boolean = false;

  //Loading section
  //tempAuditLoad: UserLocationSave = new UserLocationSave();

  //Side Panel
  showSidePanel: boolean = true;
  sidePanelUserChange: boolean = false;

  hasHeader: boolean = false;
  hasMissingQuestions: boolean = false;
  missingQuestions: number = 0;
  missingRequiredQuestions: number = 0;
  missingActions: number = 0;
  showOnlyMissingQuestions: boolean = false;
  showSummaryInformation: boolean = false;

  actionUsers: BasicUser[] = [];

  reloadedAudit: boolean = false;

  currentGUID: string = '';
  firstGUID: string = '';
  nextGUID: string = '';
  prevGUID: string = '';

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  actionCounter: number = 0;
  totalScore: number = 0;
  possibleScore: number = 0;
  percentageScore: number = 0;

  currentAuditGUID: string = '';

  constructor(
    private as: AuditService,
    private router: Router,
    private guidService: AuditGuidService,
    private localStorage: LocalStorageService,
    private userService: AuthService,
    private auditService: AuditService,
    private toast: ToastrService,
    private actionService: ComplianceActionService
  ) {
    if (this.router.currentNavigation()?.extras.state!['SavedAudit'] != undefined) {
      this.currentData = new FlattenedQuestionHolder(this.router.currentNavigation()?.extras.state!['SavedAudit']);
      this.currentAuditGUID = this.router.currentNavigation()?.extras.state!['AuditGUID'];
      this.location = new AuditLocation(this.router.currentNavigation()?.extras.state!['SavedLocation']);
      this.currentQuestion = this.currentData.Questions[0];
      this.guidService.setBranchGUIDs(this.currentData.Questions, true);
      this.isFirstHeader();
      this.setFirstQuestion();
      this.setActionUsers();
    } else {
      this.location = new AuditLocation(this.router.currentNavigation()?.extras.state![
        'location'
      ]);
      this.currentData = new FlattenedQuestionHolder(this.router.currentNavigation()?.extras.state![
        'audit'
      ]);
      if (this.router.currentNavigation()?.extras.state!.hasOwnProperty('isEvent')){
        this.currentData.IsEventAudit = this.router.currentNavigation()?.extras.state!['isEvent'];
      }
      if (this.router.currentNavigation()?.extras.state!.hasOwnProperty('EventWorkflowID')){
        this.EventWorkflowID = this.router.currentNavigation()?.extras.state!['EventWorkflowID'];
      }
    }

  }
  ngOnInit() {
    if (this.currentData != undefined) {
      this.ensureCurrentAuditGUID();
      if (this.currentData.AuditID == -1) {
        this.router.navigateByUrl('/home');
      }
      if (this.auditHasData(this.currentData)) {
        this.reloadedAudit = true;
      } else {
        this.as
          .getAudit(this.currentData.AuditID, this.location.LocationID)
          .pipe(
            tap((res: AuditResult) => {
              if (res.IsError) {

              } else {

                this.currentData = new FlattenedQuestionHolder(res.QuestionHolder);
                if (this.EventWorkflowID != -1){
                  this.currentData.EventWorkflowID = this.EventWorkflowID;
                }
                this.setGUIDs();
                this.isFirstHeader();
                this.setActionUsers();
              }
              this.pageReady = true;
            })
          )
          .subscribe();
      }

    } else {
      //this.router.navigateByUrl('/home');
    }
    if (this.currentData.AuditID != -1) {
      this.pageReady = true;
    }
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt: Event) => {
      this.checkScreenSize();
    });
    this.checkScreenSize();
  }
  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe();
  }
  setActionUsers() {
    this.actionUsers = [];
    if (navigator.onLine) {
      this.fetchCurrentActionUserList()
    } else {
      this.currentData.ActionUsers.forEach(e => {
        this.actionUsers.push(new BasicUser(e))
      });
    }

  }
  arrangeActionUsers() {
    this.actionUsers = this.actionUsers.sort((a, b) => { if (a.UserTypeID == b.UserTypeID) { return a.DisplayName.localeCompare(b.DisplayName) } else { return b.UserTypeID - a.UserTypeID } });
    if (this.actionUsers.some(e => e.UserID == -1)) {
      var IX = this.actionUsers.findIndex(e => e.UserID == -1);
      this.actionUsers.splice(IX, 1);
    }
    var newUser = new BasicUser({ 'UserID': -1, 'DisplayName': 'Please Select...', 'Seq': 0, 'UserTypeID': 0 });
    this.actionUsers.unshift(newUser);

  }
  actionCounting() {
    this.actionCounter = 0;
    this.currentData.Questions.forEach(q => {
      if (!q.BranchedOut) {
        this.actionCounter += q.CompletionInfo.Actions.length
      }
    })
  }
  scoreCalculation() {
    this.possibleScore = 0;
    this.totalScore = 0;
    this.currentData.Questions.forEach(q => {
      var localMaxScore: number = 0;
      if (q.CompletionInfo.QuestionAnswered && !q.NASelected && !q.ExcludeScoreFromTotal && !q.BranchedOut) {
        if (q.QuestionType.ID == 1 || q.QuestionType.ID == 2) {
          if (q.MaxScore > 0) {
            this.possibleScore += q.MaxScore
          } else {
            q.QuestionAnswers.forEach(a => {
              if (a.ComplianceScore > localMaxScore) {
                localMaxScore = a.ComplianceScore;
              }
            })
            this.possibleScore += localMaxScore;
          }
          this.totalScore += Math.min(q.QuestionAnswers.find(qa => qa.QuestionAnswerID == q.CompletionInfo.Answer)!.ComplianceScore, this.possibleScore);
        }
        if (q.QuestionType.ID == 3) {

          var localMultiScore = 0;
          var localAnswerTotal = 0;
          q.QuestionAnswers.forEach(a => {
            if (a.ComplianceScore > 0) {
              localMultiScore += a.ComplianceScore;
            }
            if (a.Selected) {
              if (a.ComplianceScore > 0) {
                localAnswerTotal += a.ComplianceScore;
              }
            }
          })

          if (q.MaxScore > 0) {
            this.possibleScore += q.MaxScore
          } else {
            this.possibleScore += localMultiScore;
          }
          this.totalScore += Math.min(localAnswerTotal, this.possibleScore);
        }
      }
    });
    if (this.possibleScore > 0) {
      this.percentageScore = Math.floor((this.totalScore / this.possibleScore) * 100);
    }
  }
  getRepeatQuestion(QuestionID: number): string {
    return this.currentData.Questions.find(e => e.QuestionID == QuestionID)!.QuestionHeader
  }
  createNewQuestionStructure(Questions: QuestionHolder[]) {
    for (let e of Questions) {
      if (e.Question.QuestionID > 0) {
        this.currentData.Questions.push(e.Question);
      } else {
        this.createNewQuestionStructure(e.Sections);
      }
    }
  }
  isFirstHeader() {
    if (this.currentData.Questions[0].QuestionType.ID == 6) {
      this.hasHeader = true;
      this.currentHeader = this.currentData.Questions[0].QuestionHeader;
    }
  }
  showHeader() {
    if (this.hasHeader) {
      if (this.currentQuestion.QuestionType.ID != 6) {
        return true;
      }
    }
    return false;
  }
  setHeader() {
    if (this.currentQuestion.QuestionType.ID == 6) {
      this.currentHeader = this.currentQuestion.QuestionHeader;
      this.hasHeader = true;
    } else {
      var newHeader = this.searchForHeader();
      if (newHeader == '') {
        this.hasHeader = false;
      } else {
        this.currentHeader = newHeader;
        this.hasHeader = true;
      }
    }
  }
  searchForHeader(): string {
    var currentIndex = this.currentData.Questions.findIndex((e) => {
      return e.GUID == this.currentQuestion.GUID;
    });
    var newHeading = '';
    for (let i = 0; i < currentIndex; i++) {
      if (this.currentData.Questions[i].QuestionType.ID == 6) {
        newHeading = this.currentData.Questions[i].QuestionHeader;
      }
    }
    return newHeading;
  }
  showHeadingSection() {
    return this.showLocation() && this.showAuditName();
  }
  showLocation(): boolean {
    if (this.location != undefined) {
      return true;
    }
    return false;
  }
  showAuditName(): boolean {
    if (this.currentData != undefined && this.currentData.AuditName.length > 0) {
      return true;
    }
    return false;
  }
  setGUIDs() {
    this.guidService.setGUIDs(this.currentData.Questions);
    this.guidService.setBranchGUIDs(this.currentData.Questions);
    this.setFirstQuestion();
  }
  setFirstQuestion() {
    for (let i = 0; i < this.currentData.Questions.length; i++) {
      if (i == 0) {
        this.currentQuestion = this.currentData.Questions[i];
        if (this.currentQuestion.QuestionType.ID != 6) {
          this.firstGUID = this.currentQuestion.GUID;
        }
      } else {
        if (this.firstGUID == '') {
          if (this.currentData.Questions[i].QuestionType.ID != 6) {
            this.firstGUID = this.currentData.Questions[i].GUID;
          }
        }
      }
    }
    this.nextGUID = this.currentQuestion.NextQ;
    this.prevGUID = this.currentQuestion.PrevQ;
  }

  completeAutoBackUp() {
    var BA: BackupAudit = new BackupAudit();
    BA.AuditGUID = this.ensureCurrentAuditGUID();
    BA.JSONAudit = JSON.stringify(this.currentData);
    BA.AuditID = this.currentData.AuditID;
    BA.LocationID = this.location.LocationID;
    var machineKey: string = '';
    this.localStorage.loadData(5);
    this.localStorage.observables.localRef.find(e => { return e.ID == "deviceInfo" })?.Obs.pipe(tap((f: any) => { machineKey = f?.MachineKey || '' })).subscribe();
    BA.MachineGUID = machineKey;

    this.auditService.sendAuditAutoRecovery(BA).pipe(tap((a: BasicResult) => {
      if (a.IsError) { console.error(a.ErrorCode) }
    }),
      catchError((error: any) => {
        // This block catches network errors or HTTP failures
        console.error('Connection or HTTP error:', error);
        // Return a fallback observable to allow stream to complete
        return of(null);
      })
    ).subscribe()

    /*
    var sr: SupportRequest = new SupportRequest();
    sr.AuditDetails = this.getLocalAudits();


    if (sr.AuditDetails.length > 0) {
      this.auditService.sendAutoRecovery(sr).pipe(tap((a:BasicResult) => {
        if (a.IsError) { console.error(a.ErrorCode) }
      }),
        catchError((error:any) => {
          // This block catches network errors or HTTP failures
          console.error('Connection or HTTP error:', error);
          // Return a fallback observable to allow stream to complete
          return of(null);
        })
      ).subscribe()
    }*/
  }
  getLocalAudits(): string {
    var currentaudits: UserLocationSave[] = [];
    this.auditService.getLocalAudits().pipe(tap((res: UserLocationSave[]) => {
      res.forEach(e => {
        currentaudits.push(new UserLocationSave(e));
      })
    })).subscribe();
    return JSON.stringify(currentaudits);
  }
  nextQuestion() {
    //trigger central save
    this.completeAutoBackUp();
    var previousGUID = this.currentQuestion.GUID;
    if (this.currentQuestion.NextQ == '-1') {
      this.goToSummary();
      //no next q
    } else {
      if (this.showOnlyMissingQuestions) {
        this.setNextMissingQuestion(this.currentQuestion.NextQ);
      } else {
        if (this.currentQuestion.IsBranching) {
          if (this.currentQuestion.CompletionInfo.QuestionAnswered == false) {
            return;
          } else {
            const branchGUID = this.guidService.applyBranchSelection(
              this.currentQuestion,
              this.currentData.Questions
            );
            const nextQuestionGUID = branchGUID ?? this.getValidNext(
              this.currentQuestion.NextQ,
              this.currentData.Questions.findIndex(e => e.GUID == this.currentQuestion.GUID)
            );
            this.updateLocal();
            if (nextQuestionGUID == '-1') {
              this.goToSummary();
              return;
            }
            this.currentQuestion = this.guidService.getFlattenedQuestionByGUID(
              nextQuestionGUID,
              this.currentData.Questions
            );

          }
          this.nextGUID = this.currentQuestion.NextQ;
          this.prevGUID = previousGUID;
        } else {
          //check if next is valid, if not cycle past

          var validatatedGUID = this.getValidNext(this.nextGUID, this.currentData.Questions.findIndex(e => e.GUID == this.currentQuestion.GUID));
          if (validatatedGUID == '-1') {
            this.nextGUID = '-1';
            this.currentQuestion.NextQ = '-1';
          } else {
            this.currentQuestion = this.guidService.getFlattenedQuestionByGUID(
              validatatedGUID,
              this.currentData.Questions
            );
            this.nextGUID = this.currentQuestion.NextQ;
            this.prevGUID = previousGUID;
          }

        }


      }
    }
    this.setHeader();
  }
  getValidNext(GUID: string, IX: number): string {
    //return GUID;
    var returnValue = "-1";
    if (IX >= this.currentData.Questions.length) {
      return returnValue;
    }
    this.currentData.Questions.forEach((q, i) => {
      if (returnValue == "-1") {
        if (q.GUID == GUID) {
          if (q.BranchedOut || (q.QuestionType.ID == 6 && q.HelpText.length == 0)) {
            returnValue = this.getValidNext(q.NextQ, i)
          } else {
            returnValue = q.GUID;
          }
        }
      }

    })
    return returnValue;
  }

  setNextMissingQuestion(GUID: string) {

    this.currentQuestion = this.currentData.Questions.find(
      (e) => e.GUID == this.findNextMissingQuestion(GUID)
    )!;
  }
  findNextMissingQuestion(questionGUID: string): string {
    var currentQuestion = this.guidService.getFlattenedQuestionByGUID(
      questionGUID,
      this.currentData.Questions
    );
    if (
      !currentQuestion.CompletionInfo.QuestionAnswered &&
      currentQuestion.QuestionType.ID != 6 &&
      !currentQuestion.BranchedOut
    ) {
      return questionGUID;
    } else {
      if (currentQuestion.NextQ == '-1') {
        return '-1';
        //show finish
      } else {
        return this.findNextMissingQuestion(currentQuestion.NextQ);
      }
    }
  }
  prevQuestion() {
    this.completeAutoBackUp();
    if (this.currentQuestion.PrevQ == '-1') {
      //no prev q
    } else {
      if (this.showOnlyMissingQuestions) {
        //this.findPreviousMissingQuestion(this.currentQuestion.PrevQ);
      } else {
        var validGuid = this.getValidPrevious(this.currentQuestion.PrevQ, this.currentData.Questions.findIndex(e => e.GUID == this.currentQuestion.GUID));
        if (validGuid == '-1') {
          this.currentQuestion.PrevQ = '-1';
        } else {
          this.currentQuestion = this.guidService.getFlattenedQuestionByGUID(
            validGuid,
            this.currentData.Questions
          );
          this.prevGUID = this.currentQuestion.PrevQ;
          this.nextGUID = this.currentQuestion.NextQ;
        }

      }
    }
    this.setHeader();
  }
  getValidPrevious(GUID: string, IX: number): string {
    var returnValue = "-1";
    if (IX <= 0) {
      return returnValue;
    }
    this.currentData.Questions.forEach((q, i) => {
      if (returnValue == "-1") {
        if (q.GUID == GUID) {
          if (q.BranchedOut || (q.QuestionType.ID == 6 && q.HelpText.length == 0)) {
            returnValue = this.getValidPrevious(q.PrevQ, i)
          } else {
            returnValue = q.GUID;
          }
        }
      }

    })
    return returnValue;
  }
  jumpToQuestion(GUID: string) {
    this.completeAutoBackUp();
    this.showSummaryInformation = false;
    this.hasMissingQuestions = false;
    this.currentQuestion = this.guidService.getFlattenedQuestionByGUID(
      GUID,
      this.currentData.Questions
    );
    this.nextGUID = this.currentQuestion.NextQ;
    this.prevGUID = this.currentQuestion.PrevQ;
    this.checkAutoCloseSidePanel();
    this.setHeader();
  }
  goToSummary() {
    this.completeAutoBackUp();
    this.showSummaryInformation = true;
    this.showSidePanel = false;
    this.validateFlattenedQuestions();
    this.actionCounting();
    this.scoreCalculation();
    this.setHeaderToAuditName();
  }
  returnFromSummary() {
    this.showSummaryInformation = false;
    this.showSidePanel = true;
  }
  repeatSection() {
    if (this.currentQuestion.IsRepeatEnd) {
      this.insertNewSection(this.currentQuestion);
      this.nextGUID = this.currentQuestion.NextQ;
      this.localSaveIfQuestionsAnswered();
    }
  }
  canClear(): boolean {
    var counter = 0;
    this.currentData.Questions.forEach(e => {
      if (e.QuestionID == this.currentQuestion.QuestionID) {
        counter++;
      }
    })
    if (counter < 2) {
      return false;
    } else {
      return true;
    }
  }
  clearRepeat() {

    //run through from current guid through next guids until reaching repeat end
    //confirm it is the correct question ID and not nested repeat
    //get GUID from question following the repeat section or confirm there is none
    //get GUID from question prior to the repeat section or confirm there is none
    //if following guid and prior guid - assign relevant next and prior guids
    //if no following guid remove prior question next guid
    //if no prior guid remove prev guid from following
    //move current question to prior question, unless none exist then move to next
    //remove all questions on list
    var guidlist: string[] = [];
    guidlist.push(this.currentQuestion.GUID);
    var updateguidlist = this.getRepeatGUIDs(this.currentQuestion.GUID, guidlist);
    var lastGUID = '';
    if (updateguidlist.length == 0) {
      lastGUID = this.currentQuestion.GUID;
    } else {
      lastGUID = updateguidlist[updateguidlist.length - 1];
    }

    var nextGUID = this.currentData.Questions.find(e => e.GUID == lastGUID)!.NextQ;
    var prevGUID = this.currentQuestion.PrevQ;
    //set following question with previous guid
    if (nextGUID != "-1") {
      this.currentData.Questions.find(e => e.GUID == nextGUID)!.PrevQ = prevGUID;
    }
    //set previous question to have next guid
    if (prevGUID != "-1") {
      this.currentData.Questions.find(e => e.GUID == prevGUID)!.NextQ = nextGUID;
    }
    if (prevGUID != "-1") {
      this.jumpToQuestion(prevGUID);
    } else {
      this.jumpToQuestion(nextGUID);
    }
    this.removeQuestions(guidlist);

  }
  removeQuestions(removeList: string[]) {
    removeList.forEach(e => {
      var indexRemoveAt = this.currentData.Questions.findIndex(f => f.GUID == e)
      this.currentData.Questions.splice(indexRemoveAt, 1);
    });
    this.localSaveIfQuestionsAnswered();
  }
  getRepeatGUIDs(currentGUID: string, guids: string[]): string[] {
    if (this.currentQuestion.IsRepeatEnd && this.currentQuestion.RepeatQuestionIDs.length == 0) {
      //single question repeat
    } else {
      var nextGUID = this.currentData.Questions.find(e => e.GUID == currentGUID)!.NextQ
      //stop infinite loop if end guid is reached
      if (nextGUID == "-1") {
        return [];
      }
      guids.push(nextGUID);
      var nextQuestion = this.currentData.Questions.find(e => e.GUID == nextGUID);
      if (nextQuestion!.QuestionID != this.currentQuestion.RepeatEndID) {
        var newGuids = this.getRepeatGUIDs(nextGUID, guids);
        guids = newGuids;
      }
    }
    return guids;
  }

  cleanQuestion(q: Question): Question {
    q.GUID = crypto.randomUUID();
    q.CompletionInfo = new QuestionCompletionInfo;
    if (q.QuestionAnswers.length > 0) {
      var cleanedAnswers: QuestionAnswer[] = [];
      q.QuestionAnswers.forEach(e => {
        var qa: QuestionAnswer = new QuestionAnswer(e)
        qa.Selected = false
        cleanedAnswers.push(qa);
      })
      q.QuestionAnswers = cleanedAnswers;
    }
    q.NASelected = false;
    q.BranchedOut = false;
    return q;
  }
  insertNewSection(repeatQuestion: Question) {
    var newRepeatEnd: Question = Object.assign({}, repeatQuestion);
    newRepeatEnd = this.cleanQuestion(newRepeatEnd);
    //newRepeatEnd.GUID = crypto.randomUUID();
    newRepeatEnd.NextQ = repeatQuestion.NextQ;
    //newRepeatEnd.CompletionInfo = new QuestionCompletionInfo();

    var prevQuestion = repeatQuestion.GUID;
    var nextQuestion = repeatQuestion.NextQ;
    var newQuestionArray: Question[] = [];
    for (var i: number = 0; i < repeatQuestion.RepeatQuestionIDs.length; i++) {
      var newQuestion: Question = Object.assign(
        {},
        this.currentData.Questions.find(e => { return e.QuestionID == repeatQuestion.RepeatQuestionIDs[i] })
      );
      newQuestion = this.cleanQuestion(newQuestion);
      if (i == 0) {
        newQuestion.PrevQ = prevQuestion;
      }
      if (i == repeatQuestion.RepeatQuestionIDs.length - 1) {
        newQuestion.NextQ = newRepeatEnd.GUID;
      }

      newQuestionArray.push(newQuestion);

    }
    if (newQuestionArray.length == 0) {
      newRepeatEnd.PrevQ = repeatQuestion.GUID;
      this.currentData.Questions.find((e) => {
        return e.GUID == prevQuestion;
      })!.NextQ = newRepeatEnd.GUID;
    } else {
      newRepeatEnd.PrevQ = newQuestionArray[newQuestionArray.length - 1].GUID;
      for (var i: number = 0; i < newQuestionArray.length; i++) {
        if (i < newQuestionArray.length - 1) {
          newQuestionArray[i].NextQ = newQuestionArray[i + 1].GUID;
        } else {
          newQuestionArray[i].NextQ = newRepeatEnd.GUID;
        }
        if (i != 0) {
          newQuestionArray[i].PrevQ = newQuestionArray[i - 1].GUID;

        }
        if (i == 0) {
          this.currentQuestion = newQuestionArray[i];

        }
        this.currentData.Questions.push(newQuestionArray[i]);
      }
      this.currentData.Questions.find((e) => {
        return e.GUID == prevQuestion;
      })!.NextQ = newQuestionArray[0].GUID;
    }

    this.currentData.Questions.push(newRepeatEnd);

    //set the prev guid of the question following the insert
    /*this.currentData.Questions.find((e) => {
      return e.GUID == nextQuestion;
    })!.PrevQ = newQuestionArray[newQuestionArray.length - 1].GUID;*/
    //this.currentData.Questions.find(e => e.GUID == nextQuestion)!.PrevQ = newRepeatEnd.GUID;
    this.orderFlattenedQuestions();

  }
  updateAnswer(e: any) {
    this.currentQuestion.CompletionInfo.Answer = e;
    this.updateLocal();
  }
  triggerLocalSave() {
    this.updateLocal();

  }
  localSaveIfQuestionsAnswered() {
    var hasAnsweredQuestions = false;
    this.currentData.Questions.forEach(e => {
      if (e.CompletionInfo.QuestionAnswered) {
        hasAnsweredQuestions = true;
      }
    })
    if (hasAnsweredQuestions) {
      this.updateLocal();
    }
  }
  updateValidAnswerState(e: boolean) {
    this.currentQuestion.CompletionInfo.QuestionAnswered = e;
  }
  updateCurrentQuestion(q: Question) {
    this.currentQuestion.CompletionInfo = structuredClone(q).CompletionInfo;
    this.updateLocal();
  }
  updateLocal() {
    const auditGUID = this.ensureCurrentAuditGUID();
    var username = '';
    this.userService.getUserName()
      .pipe(
        tap((a: any) => {
          username = a.Username.toLowerCase();
        })
      )
      .subscribe();
    if (username == null) {
      return;
    }
    var localData: any;
    this.auditService.getALLLocalAudits()
      .pipe(
        tap((a: UserLocationSave[]) => {
          localData = a;
        })
      )
      .subscribe();
    if (localData == null) {
      var ls: UserLocationSave = {
        Username: username.toLowerCase(),
        Location: this.location,
        FlattenedQuestions: [],
        AuditGUID: auditGUID,
        LastUpdate: new Date(),
        LastUpdateSet: true,
        CloudSave: false
      };
      ls.FlattenedQuestions.push(this.currentData);
      var saveList: UserLocationSave[] = [];
      saveList.push(ls);
      this.localStorage.setData(2, saveList);
    } else {
      var parsedData: UserLocationSave[] = <UserLocationSave[]>localData;
      var currentSet: UserLocationSave = new UserLocationSave();
      var localDataIndex = parsedData.findIndex((e) => {
        return e.Username.toLowerCase() == username.toLowerCase() && e.AuditGUID == auditGUID;
        //return e.Username == username && e.Location.LocationID == this.location.LocationID && e.FlattenedQuestions[0].AuditID == this.currentData.AuditID;
      });
      if (localDataIndex != -1) {
        currentSet = parsedData.find((f) => {
          return f.Username.toLowerCase() == username.toLowerCase() && f.AuditGUID == auditGUID;
          //return f.Username == username && f.Location.LocationID == this.location.LocationID && f.FlattenedQuestions[0].AuditID == this.currentData.AuditID;
        })!;
        if (currentSet.FlattenedQuestions.some((g) => { return g.AuditID == this.currentData.AuditID; })) {
          var tempQuestions: Question[] = [];
          this.currentData.Questions.forEach(e => {
            tempQuestions.push(new Question(e));
          })
          currentSet.FlattenedQuestions.find((h) => {
            return h.AuditID == this.currentData.AuditID;
          })!.Questions = tempQuestions;
          currentSet.LastUpdate = new Date();
          currentSet.LastUpdateSet = true;
        } else {
          currentSet = {
            AuditGUID: auditGUID,
            Username: username.toLowerCase(),
            Location: this.location,
            LastUpdate: new Date(),
            LastUpdateSet: true,
            CloudSave: false,
            FlattenedQuestions: [
              /*new FlattenedQuestionHolder({
                AuditID: this.currentData.AuditID,
                AuditName: this.currentData.AuditName,
                Questions: this.currentData.Questions,
                ActionUsers: this.actionUsers
              }),*/
              this.currentData,
            ],
          };
          parsedData.push(currentSet);
        }
      } else {
        currentSet = {
          AuditGUID: auditGUID,
          Username: username.toLowerCase(),
          Location: this.location,
          LastUpdate: new Date(),
          LastUpdateSet: true,
          CloudSave:false,
          FlattenedQuestions: [
            /*new FlattenedQuestionHolder({
              AuditID: this.currentData.AuditID,
              AuditName: this.currentData.AuditName,
              Questions: this.currentData.Questions,
              ActionUsers: this.actionUsers
            }),*/
            this.currentData,
          ],
        };
        parsedData.push(currentSet);
      }
      this.localStorage.setData(2, parsedData);
    }
  }
  validateAudit() {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    if (!this.validateFlattenedQuestions()) {
      this.hasMissingQuestions = true;
      this.submitting = false;
    } else {
      this.saveAudit()
    }
  }
  validateFlattenedQuestions(): boolean {
    var returnValue: boolean = true;
    this.missingQuestions = 0;
    this.missingRequiredQuestions = 0;
    this.missingActions = 0;
    this.currentData.Questions.forEach((e) => {
      if (!e.CompletionInfo.QuestionAnswered && e.QuestionType.ID != 6 && !e.NASelected && !e.BranchedOut) {
        this.missingQuestions++;
        if (e.Required) {
          returnValue = false;
          this.missingRequiredQuestions++;
        }
      }
      if (!e.BranchedOut && !e.NASelected && e.CompletionInfo.QuestionAnswered && e.CompletionInfo.NonCompliant && (e.CompletionInfo.Actions.length == 0 || e.CompletionInfo.Actions.length == undefined)) {
        this.missingActions++;
        returnValue = false;
      }
    });
    return returnValue;
  }
  saveAudit() {
    var AH: AuditHolder = new AuditHolder();
    AH.LocationID = this.location.LocationID;
    AH.AuditGUID = this.ensureCurrentAuditGUID();
    AH.Audit = this.currentData;
    AH.Audit.AuditCompletionInfo.SubmittedDate = new Date();
    this.auditService.saveAudit(AH).pipe(
      tap((a: ActionResult) => {
        this.auditSuccess(a);
      })
    ).subscribe();
  }
  auditSuccess(BR: ActionResult) {
    if (BR.IsError == false) {
      var username = this.getUsername();
      this.auditService.removeLocalAudit(this.currentAuditGUID, username);
      this.toast.addToastr(new Toastr({ Type: 2, Message: "Audit submitted." }));
      this.router.navigateByUrl('/home');
    } else {
      this.submitting = false;
      this.toast.addToastr(new Toastr({ Type: 3, Message: "Unable to submit audit, please try again." }));
      this.submittingIssue = true;
    }
  }
  private ensureCurrentAuditGUID(): string {
    if (!this.currentAuditGUID || this.currentAuditGUID.length == 0) {
      this.currentAuditGUID = crypto.randomUUID();
    }

    return this.currentAuditGUID;
  }
  getUsername(): string {
    var username: string = "";
    this.userService.getUserName()
      .pipe(
        tap((a: any) => {
          username = a.Username;
        })
      )
      .subscribe();
    return username;

  }
  orderFlattenedQuestions() {
    this.currentData.Questions = this.guidService.orderFlattenedQuestions(this.currentData.Questions);
  }
  showOnlyMissing() {
    this.showOnlyMissingQuestions = true;
    this.showSummaryInformation = false;
    this.setNextMissingQuestion(this.findNextMissingQuestion(this.firstGUID));
    this.setHeader();
    this.hasMissingQuestions = false;
  }
  switchShowSidePanel() {
    if (this.showSidePanel) {
      this.showSidePanel = false;
    } else {
      this.showSidePanel = true;
    }
    this.sidePanelUserChange = true;
  }
  checkScreenSize() {
    if (window.innerWidth < 1024) {
      this.showSidePanel = false;
    } else if (this.sidePanelUserChange == false) {
      this.showSidePanel = true;
    }
  }
  checkAutoCloseSidePanel() {
    if (window.innerWidth < 1024 && this.showSidePanel) {
      this.showSidePanel = false;
    }
  }
  setHeaderToAuditName() {
    this.currentHeader = this.currentData.AuditName;
  }
  auditHasData(FQH: FlattenedQuestionHolder): boolean {
    var counter = 0;
    FQH.Questions.forEach(e => {
      if (e.CompletionInfo.Answer != null) {
        counter++;
      }
    })
    return counter > 0;
  }
  fetchCurrentActionUserList() {
    var request: ActionUserRequest = new ActionUserRequest();
    request.AuditID = this.currentData.AuditID;
    request.LocationID = this.location.LocationID;
    this.actionService.getActionUsers(request).pipe(tap((res: BasicUser[]) => {
      this.actionUsers = [];
      this.currentData.ActionUsers = [];
      res.forEach(e => {
        if (this.actionUsers.findIndex(f => {
          return f.UserID == e.UserID
        }) == -1) {
          this.actionUsers.push(new BasicUser(e));
          this.currentData.ActionUsers.push(new BasicUser(e))
        }


      });

      this.triggerLocalSave();
      this.arrangeActionUsers();
    })).subscribe();

  }
}
